import { render, staticRenderFns } from "./Ing.vue?vue&type=template&id=586874a7&scoped=true&"
import script from "./Ing.vue?vue&type=script&lang=js&"
export * from "./Ing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586874a7",
  null
  
)

export default component.exports